export default __webpack_public_path__ + "static/media/wenzilianjie.f5660c02.png";